import React, { useState } from "react";
import { createPortal } from "react-dom";
import { Modal, Form, Input, Button, message } from "antd";
import { useCreateSparePartMutation } from "../../../Redux/service/CallCenter/CallCenter";
import trans from "../../../utils";

const { TextArea } = Input;

const CreateSparePartModal = ({ visible, onClose, issueId, onSuccess }) => {
  const [form] = Form.useForm();
  const [createSparePart, { isLoading }] = useCreateSparePartMutation();
  const lang = localStorage.getItem("lang") === "ar" ? "ar" : "en";

  const handleSubmit = async (values) => {
    try {
      const result = await createSparePart({
        issueId: Number(issueId),
        partCode: values.partCode,
        name: values.name,
        nameAr: values.nameAr,
        description: values.description || undefined,
        descriptionAr: values.descriptionAr || undefined,
      }).unwrap();

      message.success(
        lang === "ar" ? "تم إنشاء قطعة الغيار بنجاح" : "Spare part created successfully"
      );
      form.resetFields();
      onSuccess(result.data);
      onClose();
    } catch (err) {
      message.error(err?.data?.message || "Something went wrong");
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onClose();
  };

  return createPortal(
    <Modal
      title={lang === "ar" ? "إضافة قطعة غيار جديدة" : "Add New Spare Part"}
      open={visible}
      onCancel={handleCancel}
      footer={null}
      width={600}
      zIndex={2000}
      destroyOnClose={true}
      maskClosable={false}
    >
      <Form form={form} layout="vertical" onFinish={handleSubmit}>
        <Form.Item
          label={lang === "ar" ? "كود القطعة" : "Part Code"}
          name="partCode"
          rules={[{ required: true, message: lang === "ar" ? "مطلوب" : "Required" }]}
        >
          <Input placeholder={lang === "ar" ? "أدخل كود القطعة" : "Enter part code"} />
        </Form.Item>

        <Form.Item
          label={lang === "ar" ? "الاسم (إنجليزي)" : "Name (English)"}
          name="name"
          rules={[{ required: true, message: lang === "ar" ? "مطلوب" : "Required" }]}
        >
          <Input placeholder={lang === "ar" ? "أدخل الاسم بالإنجليزية" : "Enter name in English"} />
        </Form.Item>

        <Form.Item
          label={lang === "ar" ? "الاسم (عربي)" : "Name (Arabic)"}
          name="nameAr"
          rules={[{ required: true, message: lang === "ar" ? "مطلوب" : "Required" }]}
        >
          <Input
            placeholder={lang === "ar" ? "أدخل الاسم بالعربية" : "Enter name in Arabic"}
            dir="rtl"
          />
        </Form.Item>

        <Form.Item
          label={lang === "ar" ? "الوصف (إنجليزي)" : "Description (English)"}
          name="description"
        >
          <TextArea
            rows={3}
            placeholder={lang === "ar" ? "أدخل الوصف بالإنجليزية" : "Enter description in English"}
          />
        </Form.Item>

        <Form.Item
          label={lang === "ar" ? "الوصف (عربي)" : "Description (Arabic)"}
          name="descriptionAr"
        >
          <TextArea
            rows={3}
            placeholder={lang === "ar" ? "أدخل الوصف بالعربية" : "Enter description in Arabic"}
            dir="rtl"
          />
        </Form.Item>

        <div className="d-flex justify-content-end gap-2">
          <Button onClick={handleCancel}>
            {lang === "ar" ? "إلغاء" : "Cancel"}
          </Button>
          <Button type="primary" htmlType="submit" loading={isLoading}>
            {lang === "ar" ? "إنشاء" : "Create"}
          </Button>
        </div>
      </Form>
    </Modal>,
    document.body
  );
};

export default CreateSparePartModal;
